export default __webpack_public_path__ + "static/media/navigate-list-1.6c58bcb6.png";